import React from 'react';
import PointIssueHistoryDetailInfo from '../PointIssueHistoryDetailInfo/PointIssueHistoryDetailInfo';
import PointIssueHistoryDetailItemList from '../PointIssueHistoryDetailItemList';

const PointIssueHistoryDetailWrap = (props) => {
  const { pointIssueHistoryDetail, getPointIssueHistoryPointLogList, pointCauseSelectList } = props;

  return (
    <div className="point-issue-history-detail-wrap">
      {/*포인트 발급 내역 정보*/}
      <PointIssueHistoryDetailInfo pointIssueHistoryInfo={pointIssueHistoryDetail.pointIssueHistoryInfo} />

      {/*포인트 발급 내역 아이템 리스트*/}
      <PointIssueHistoryDetailItemList
        pointCauseSelectList={pointCauseSelectList}
        pointIssueHistoryItemList={pointIssueHistoryDetail.pointIssueHistoryItemList.list}
        getPointIssueHistoryPointLogList={getPointIssueHistoryPointLogList}
        filterOption={pointIssueHistoryDetail.pointIssueHistoryItemList.filterOption}
        pagination={pointIssueHistoryDetail.pointIssueHistoryItemList.pagination}
      />
    </div>
  );
};

export default PointIssueHistoryDetailWrap;
